//
// Partner carousel
//

$(function() {
    var partnerCarousel = $('.quote-carousel__carousel'),
        autoPlayTimeout = 5000;

    // Initialize carousel
    partnerCarousel.owlCarousel({
        loop: false,
        nav: true,
        dots: true,
        autoplayTimeout: autoPlayTimeout,
        mouseDrag: false,
        touchDrag: false,
        pullDrag: false,
        freeDrag: false,
        navText: ['<span class="sr-only">Previous</span><i class="fal fa-chevron-left" aria-hidden="true"></i>', '<span class="sr-only">Next</span><i class="fal fa-chevron-right" aria-hidden="true"></i>'],
        responsive: {
            0: {
                items: 1,
            }
        }
    });
    
    // Initialize owl tabbing plugin
    partnerCarousel.owlTabbing();

    // Fix bug where navigation items disappear on load
    partnerCarousel
        .find('.owl-nav')
        .removeClass('disabled');

    // Fix bug where navigation items disappear on change and resize
    partnerCarousel.on('changed.owl.carousel resized.owl.carousel', function(event) {
        $(this)
            .find('.owl-nav')
            .removeClass('disabled');
    });
});